import { useParams, useNavigate } from 'react-router-dom';
import TabButtons from './TabButtons';
import FetchPosts from '../Helpers/fetchPosts';
import { useGlobalState } from '../contexts/GlobalStateContext';

const Popular = () => {
  const navigate = useNavigate();
  const { period } = useParams();
  const { globalState } = useGlobalState();

  const openPage = (tab) => {
    navigate(`/popular/${tab}`);
  };

  return (
    <>
      {!globalState.fullScreenPost && (
        <TabButtons activeTab={period} openPage={openPage} />
      )}

      <FetchPosts
        key={`popular-${period}`}
        pageParam={period}
      />

    </>
  );
};

export default Popular;
